
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LocaleItemProps } from ".";
import { loading, create } from "store/locale";
import { AppMessage } from "components";

interface ApiLocaleCreateInputProps extends Omit<LocaleItemProps, "id"> {
}

type ApiLocaleCreateOutputProps = OutputBaseProps<{ item: LocaleItemProps; }, ApiLocaleCreateInputProps>

export const apiLocaleCreate = async (data: ApiLocaleCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiLocaleCreateOutputProps>("/api/locale/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};